import { styled } from 'stitches.config'

export const IngredientsRoot = styled('div', {
  width: '100%',
  background: '$tertiary-200',
  padding: '0px 0px 64px 0px',

  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  alignItems: 'center',

  '@bp3': {
    padding: '0px 24px 64px 24px',
  },

  variants: {
    padding: {
      true: {
        padding: '0px 0px 64px 0px',
        '@bp3': {
          paddingTop: '$12',
        }
      }
    },
  }
})

export const Container = styled('div', {
  maxWidth: '380px',
  margin: 'auto',
  position: 'relative',
  '@bp3': {
    maxWidth: '1800px',
    margin: 'auto 32px',
  },
})

export const BannerWrapper = styled('div', {
  position: 'relative',
  height: '267px',
  width: '900px',
  display: 'none',
  '@bp3': {
    height: '264px',
    width: '1920px',
    display: 'block',
  },
})

export const BannerImage = styled('div', {
  display: 'none',
  '@bp2': { display: 'block' },
})

export const BannerText = styled('div', {
  margin: 'auto',
  width: '100%',
  display: 'none',

  '@bp3': {
    width: '100%',
    display: 'block',
  },
})

export const IngredientsWrapper = styled('div', {
  display: 'none',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  gap: '0',

  flexWrap: 'no-wrap',
  scrollbarColor: '$primary-700 $accent-white',
  '&::-webkit-scrollbar': {
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '$accent-white',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '$primary-700',
    borderRadius: '8px',
  },
  '@bp3': {
    display: 'flex',
  },

  variants: {
    scrollable: {
      true: {
        overflowX: 'scroll',
      },
      false: {
        overflowX: 'none',
      },
    },
  },
})

export const SectionTitle = styled('h2', {
  color: '$primary-500',
  fontWeight: '$semiBold',
  fontSize: '$h2',
  letterSpacing: '1px',
  textAlign: 'center',
  lineHeight: '$h1',

  '@bp3': {
    fontSize: '$h1',
    textAlign: 'left',
  },

  variants: {
    align: {
      center: {
        textAlign: 'center',
        '@bp3': { textAlign: 'center' },
      },
    },
  },
})

export const Subtitle = styled('h3', {
  color: '$accent-black',
  fontWeight: '$semiBold',
  fontSize: '$h4',
  letterSpacing: '1px',
  textAlign: 'center',
  lineHeight: '$h4',
  marginTop: '24px',
})


export const IngredientsCard = styled('div', {
  flex: '0 0 20%',
  boxSizing: 'border-box',
  display: 'flex',
  marginTop: '24px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  position: 'relative',
  padding: '0px 48px',
  '@bp3': {
    padding: '20px 30px',
    marginTop: '32px',
  },

  '@bp4': {
    padding: '20px 40px',
  },
})

export const CardImage = styled('div', {
  width: '210px',
  position: 'relative',
  top: 0,
  left: 0,
  right: 0,
  margin: 'auto',

  '@bp3': {
    position: 'absolute',
    right: '54px',
  },

  variants: {
    icon: {
      venison: {
        '@bp3': {
          top: '-50px',
        },
      },
      heart: {},
      liver: {},
      kidney: {},
      bone: {},
    },
  },
})

export const CardText = styled('div', {
  paddingBottom: '48px',
  margin: 'auto',
  textAlign: 'center',
  '@bp3': {
    paddingTop: '220px',
    margin: 'none',
    textAlign: 'left',
  },
})

export const Footer = styled('div', {
  width: '100%',
  maxWidth: '300px',
  fontStyle: 'italic',
  fontSize: '$caption',
  fontWeight: '$semiBold',
  color: '$accent-black',
  textAlign: 'center',
  margin: 'auto',
  marginTop: '48px',
  padding: '0 16px',

  display: 'block',
  '@bp3': {
    display: 'block',
    padding: 0,
    marginTop: '36px',
    fontSize: '$small',
    maxWidth: '800px',
  },
})

export const MobileWrapper = styled('div', {
  display: 'block',
  paddingTop: '48px',

  '@bp3': {
    display: 'none',
  },
})

export const SliderContainer = styled('div', {
  display: 'block',

  '& .slick-list': {
    zIndex: 1,
  },

  '& .slick-dots': {
    bottom: '-3px',
    zIndex: 2,
  },

  '& .slick-dots li button:before': {
    fontSize: '12px',
    color: '$accent-white',
    opacity: 1,
  },

  '& .slick-dots li.slick-active button:before': {
    color: '$primary-500',
    opacity: 1,
  },
})

export const BorderWrapper = styled('div', {
  background: '$tertiary-200',
  display: 'none',
  '@bp3': {
    display: 'block',
  }
})
